import { createSlotsContext } from '@grandvisionhq/slots';

const [CartFooterSlotsProvider, useCartFooterSlots] = createSlotsContext({
    displayName: 'CartFooterSlotsContext'
});

export { CartFooterSlotsProvider, useCartFooterSlots };
//# sourceMappingURL=context.js.map
